import { formatCurrencyCompact, formatPercent } from "@/lib/format";

/**
 * Inline spend-vs-budget meter for table rows. The unfilled track is a
 * lighter step of the fill's own ramp so state reads across the whole bar;
 * the value rides beside it in ink, never inside the fill.
 */
export function BudgetMeter({
  spend,
  budget,
}: {
  spend: number;
  budget: number | null;
}) {
  if (budget == null || budget <= 0) {
    return <span className="text-muted-foreground">—</span>;
  }
  const ratio = Math.min(1, spend / budget);
  return (
    <span className="inline-flex items-center gap-2">
      <span
        className="inline-block h-1.5 w-20 overflow-hidden rounded-full"
        style={{ background: "var(--viz-meter-track)" }}
        role="meter"
        aria-valuemin={0}
        aria-valuemax={budget}
        aria-valuenow={Math.min(spend, budget)}
        aria-valuetext={`${formatPercent(spend / budget, 0)} of budget used`}
        aria-label={`Spend ${formatCurrencyCompact(spend)} of ${formatCurrencyCompact(budget)} budget`}
      >
        <span
          className="block h-full rounded-full"
          style={{
            width: `${ratio * 100}%`,
            background: "var(--viz-series-1)",
          }}
        />
      </span>
      <span className="text-xs text-muted-foreground">
        {formatPercent(spend / budget, 0)}
      </span>
    </span>
  );
}
